import { getSubmissionLimitForTier } from './tiers';

/** Shared copy for Today / Forms usage pills. */
export function formatLeadsUsageLine(usage) {
  if (!usage) return null;
  if (usage.workspacesOwned > 1) {
    return `Leads this month: ${usage.poolUsed}/${usage.submissionLimit} pooled · ${usage.workspaceUsed} here`;
  }
  return `Leads this month: ${usage.poolUsed}/${usage.submissionLimit}`;
}

export function usagePillText({ tier, usage, usageLoading, userProfile }) {
  const prefix = `Tier: ${tier || 'free'}`;
  if (usageLoading) return `${prefix} · Leads this month: …`;
  const line = formatLeadsUsageLine(usage);
  if (line) return `${prefix} · ${line}`;
  const used = userProfile?.submissionsUsed || 0;
  const limit = getSubmissionLimitForTier(userProfile?.tier, userProfile?.submissionLimit);
  return `${prefix} · Submissions: ${used}/${limit}`;
}
